module.exports = __webpack_public_path__ + "img/airpa_12.c3b6f57e.svg";